import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/plan')({
  component: () => <PageStub title="Plan" description="Strategic planning and goal setting" />,
});
